export interface Action {
  type: ActionType;
  payload?: any;
}

export enum ActionType {
  ADD_ARTICLE = 'ADD_ARTICLE',
  SELECT_ARTICLE = 'SELECT_ARTICLE',
  DISABLE_INTERACTIONS = 'DISABLE_INTERACTIONS',
  ENABLE_INTERACTIONS = 'ENABLE_INTERACTIONS',
  REMOVE_ARTICLE = 'REMOVE_ARTICLE',
  REPLACE_ARTICLE = 'REPLACE_ARTICLE',
  INIT_CONFIGURATION = 'INIT_CONFIGURATION',
  INIT_ANONYMOUS_CONFIGURATION = 'INIT_ANONYMOUS_CONFIGURATION',
  RESET_CONFIGURATION = 'RESET_CONFIGURATION',
  UPDATE_ARTICLE_COLOR = 'UPDATE_ARTICLE_COLOR',
  ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS',
  REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',
  MOVE_ARTICLE_ON_SINGLE_SLOT = 'MOVE_ARTICLE_ON_SINGLE_SLOT',
  SET_CONFIGURATION_RIGHTS = 'SET_CONFIGURATION_RIGHTS',
  LOAD_CONFIGURATION = 'LOAD_CONFIGURATION',
  LOAD_ANONYMOUS_CONFIGURATION = 'LOAD_ANONYMOUS_CONFIGURATION',
  MOVE_ARTICLE_ON_LINE_SLOT = 'MOVE_ARTICLE_ON_LINE_SLOT',
  MOVE_HEIGHT_CONTROL_PANEL = 'MOVE_HEIGHT_CONTROL_PANEL',
  VALIDATE_CONFIGURATION = 'VALIDATE_CONFIGURATION',
  SET_CONFIGURATION_CODE = 'SET_CONFIGURATION_CODE',
  SET_DIMENSIONS = 'SET_DIMENSIONS',
  REPLACE_REQUIRED_ARTICLE = 'REPLACE_REQUIRED_ARTICLE',
  SET_THEME = 'SET_THEME',
}
